import { render, staticRenderFns } from "./activeDetailTwo.vue?vue&type=template&id=35e3d470&scoped=true&"
import script from "./activeDetailTwo.vue?vue&type=script&lang=js&"
export * from "./activeDetailTwo.vue?vue&type=script&lang=js&"
import style0 from "./activeDetailTwo.vue?vue&type=style&index=0&id=35e3d470&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3d470",
  null
  
)

export default component.exports